import { isArrayLength } from './genericHelpers';
import * as listingVisibility from './listingVisibility';

const { filterPublicListings, isVacationModeListing } = listingVisibility;

export const getLikes = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.publicData?.likes || [];
};
export const getListingImage = images => {
  if (!images?.length) return [];

  return (
    images.map(image => ({
      fileLink:
        image.attributes?.variants?.['custom']?.url ||
        image.attributes?.variants?.['scaled-large']?.url,
      id: image.id,
    })) || []
  );
};

export const listingSizes = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.publicData?.sizes || [];
};

export const createValidVariantsParams = listings => {
  if (!isArrayLength(listings)) return [];

  return listings.map(listing => {
    const { attributes: { publicData } = {}, currentStock, images, id } = listing || {};
    const stock = currentStock?.attributes?.quantity || 0;
    const imagesIds = images?.map(image => image?.id?.uuid) || [];

    return {
      id: id?.uuid,
      imagesIds,
      size: publicData?.sizeOption,
      sku: publicData?.sku,
      stock,
    };
  });
};
export const createPhotoObjects = photos => {
  if (!isArrayLength(photos)) return [];

  return photos?.map(photo => ({
    original: photo,
    thumbnail: photo,
  }));
};
export const getParentId = listing => {
  return listing?.attributes?.publicData?.parentId || null;
};
export const isValidListings = listings => {
  if (!isArrayLength(listings)) return [];

  return filterPublicListings(listings).filter(
    listing => !listing?.attributes?.publicData?.parentId
  );
};

/**
 * specific helper to get vacation mode from a listing entity
 * Returns: boolean | null
 */
export const getListingVacationMode = listing => {
  // Ensure listing exists and has a valid UUID
  if (!listing?.id?.uuid) {
    return null;
  }

  return isVacationModeListing(listing);
};
